import React, { useState } from "react";
import { useAuth } from "../../context/AuthContext";
import "./login.css";

const Login = () => {
  const { handleLogin, token, user } = useAuth();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const success = await handleLogin(username, password);
      if (success) {
        setMessage("Login exitoso");
      } else {
        setMessage("Usuario o contraseña incorrectos");
      }
    } catch (error) {
      setMessage("Error al intentar iniciar sesión");
    }
  };

  if (token !== null) {
    return <p>Usuario logado como: {user}</p>;
  }

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <div className="campos-columna">
          <label>
            <b>Correo electrónico</b> (requerido)
          </label>
          <input
            type="text"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <br />
        <div className="campos-columna">
          <label>
            <b>Contraseña</b> (requerido)
          </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        <br />
        <div className="centro">
          <br />
          <button type="submit" className="btn btn-azul">
            Iniciar Sesión
          </button>
          <p className="p-3 forgot-password"> <a href="https://sede.oepm.gob.es/eSede/datos/es/recuperarPassword.html" target="_blank"  className="p-3 forgot-password">
            ¿Has olvidado tu contraseña?
          </a></p>
          <button className="btn-blue-border"   
            onClick={() => window.location.href = 'https://www.oepm.es/es/sobre-OEPM/servicios-al-ciudadano/servicios-gratuitos/Servicios-web-de-la-OEPM/lopd/'}
          >Registro nuevo usuario</button>
        </div>
        <br /><br />
      </form>
      {message && <p className="text-danger">{message}</p>}
    </div>
  );
};

export default Login;
